<template>
    <chart-doughnut
        :chart-data="chartData"
        :options="chartOptions"
    ></chart-doughnut>
</template>

<script>
import statusColors from '@/shared/statusColors';
import { randomElement } from '@/common/helpers';
import vcolors from 'vuetify/lib/util/colors';
import { mapState } from 'vuex';

export default {
    name: 'DeviceStatusChart',
    components: {
        'chart-doughnut': () => import('@/components/Charts/ChartDoughnut')
    },
    computed: {
        ...mapState('devices', ['deviceStatusSummary']),
        chartFontColor() {
            if (this.$vuetify.theme.isDark) {
                return this.colors.deepGrey.lighten2;
            }
            return this.colors.deepGrey.darken3;
        },
        chartLabelColor() {
            if (this.$vuetify.theme.isDark) {
                return this.colors.deepGrey.darken3;
            }
            return this.colors.deepGrey.lighten6;
        },
        chartSegmentsColors() {
            const colorSet = this.$vuetify.theme.isDark
                ? statusColors.dark
                : statusColors.light;
            return this.chartLabels.map(item => {
                if (colorSet[item]) {
                    return colorSet[item];
                } else {
                    return this.getRandomColor();
                }
            });
        },
        chartLabels() {
            return Object.keys(this.deviceStatusSummary);
        },
        chartElementsData() {
            return Object.keys(this.deviceStatusSummary).map(item => {
                return this.deviceStatusSummary[item].count;
            });
        },
        chartData() {
            return {
                labels: this.chartLabels,
                datasets: [
                    {
                        backgroundColor: this.chartSegmentsColors,
                        data: this.chartElementsData
                    }
                ]
            };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        fontColor: this.chartFontColor
                    },
                    onClick: null
                },
                plugins: {
                    labels: {
                        render: 'value',
                        fontColor: this.chartLabelColor
                    }
                },
                onClick: this.onChartElementClick
            };
        }
    },
    methods: {
        getRandomColor() {
            const baseColor = randomElement(Object.keys(vcolors));
            const shadeColor = randomElement(Object.keys(vcolors[baseColor]));
            const randomColor = vcolors[baseColor][shadeColor];
            return randomColor;
        },
        onChartElementClick(event, element) {
            if (element[0] !== undefined && element[0]._index !== undefined) {
                const segement = element[0];
                this.$emit('click', {
                    index: segement._index,
                    label: segement._model.label
                });
            }
        }
    }
};
</script>

<style></style>
